const DEFAULT_DPI = 96;
const INCHES_PER_METER = 39.37;

let cachedDpi: number | undefined;

export const getDisplayDpi = (): number => {
    if (cachedDpi != null) {
        return cachedDpi;
    }

    if (typeof document === 'undefined') {
        return DEFAULT_DPI;
    }

    const div = document.createElement('div');
    div.style.height = '1in';
    div.style.width = '1in';
    div.style.top = '-100%';
    div.style.left = '-100%';
    div.style.position = 'absolute';
    document.body.appendChild(div);

    cachedDpi = div.offsetHeight || DEFAULT_DPI;
    div.remove();
    return cachedDpi;
};

export const scaleToResolution = (scale: number): number => {
    return scale / (getDisplayDpi() * INCHES_PER_METER);
};

export const resolutionToScale = (resolution?: number): number | undefined => {
    if (resolution == null) {
        return undefined;
    }
    return Math.round(resolution * getDisplayDpi() * INCHES_PER_METER);
};

export const nearestScale = (scales: number[], targetScale?: number): number | undefined => {
    if (targetScale == null || scales.length === 0) {
        return undefined;
    }
    return scales.reduce((prev, curr) => (Math.abs(curr - targetScale) < Math.abs(prev - targetScale) ? curr : prev), scales[0]);
};

export const formatScaleLabel = (scale: number): string => {
    return `1 : ${scale.toLocaleString('cs-CZ', {maximumFractionDigits: 0})}`;
};
